import { GENERAL_ASSETS } from '@Animation/constants'
import { tweenPromise } from '@Animation/utils'
import { GameObjects } from 'phaser'

export class BallsRemainingDisplay extends Phaser.GameObjects.Container {
  ballIndex: number = 0
  setIndex: number = 0
  balls: GameObjects.Image[][] = []
  dividers: GameObjects.Text[] = []

  ballSets: number[] = []

  constructor(scene: Phaser.Scene, x: number, y: number, ballSets: number[]) {
    super(scene, x, y)
    scene.add.existing(this)

    this.ballSets = ballSets
    this.setAlpha(0)
  }

  async createBalls() {
    const topRowY = -8
    const bottomRowY = 8
    const xGap = 16
    let xPosition = 0

    for (let set = 0; set < this.ballSets.length; set++) {
      if (set > 0) {
        const divider = this.scene.add.text(xPosition - xGap, 0, '|')
        divider.setFontSize(32)
        divider.setOrigin(0.5, 0.5)
        this.add(divider)
        this.dividers.push(divider)
      }

      const setBalls: GameObjects.Image[] = []

      for (let ballSetIndex = 0; ballSetIndex < this.ballSets[set]; ballSetIndex++) {
        const isTopRow = ballSetIndex < Math.ceil(this.ballSets[set] / 2)
        const yPos = isTopRow ? topRowY : bottomRowY
        const xPos = isTopRow
          ? xPosition + ballSetIndex * xGap
          : xPosition + (ballSetIndex - Math.floor(this.ballSets[set] / 2)) * xGap

        const ball = await this.createBall(xPos, yPos)
        ball.setOrigin(0.5, 0.5)
        setBalls.push(ball)
      }

      this.add(setBalls)
      this.balls.push(setBalls)

      xPosition += 3 * xGap
    }

    this.setIndex = this.balls.length - 1
    this.ballIndex = this.balls[this.setIndex].length
  }

  private createBall(xPos: number, yPos: number): Promise<GameObjects.Image> {
    return new Promise((resolve) => {
      const ball = this.scene.add.image(xPos, yPos, GENERAL_ASSETS.WHITE_CIRCLE)
      ball.setOrigin(0.5, 0.5)

      resolve(ball)
    })
  }

  async removeBall() {
    this.ballIndex--
    if (this.ballIndex < 0) {
      this.setIndex--
      if (this.setIndex < 0) return

      this.ballIndex = this.balls[this.setIndex].length - 1
      const divider = this.dividers.pop()
      tweenPromise(this.scene, {
        targets: divider,
        alpha: 0,
        duration: 500,
      })()
    }

    const ball = this.balls[this.setIndex][this.ballIndex]

    await tweenPromise(this.scene, {
      targets: ball,
      scale: 2,
      alpha: 0,
      duration: 500,
    })()

    ball?.destroy()
  }

  async skip() {
    this.destroy()
  }

  destroy(fromScene?: boolean): void {
    this.balls.forEach((group) => group.forEach((ball) => ball.destroy(fromScene)))
    this.dividers.forEach((divider) => divider.destroy(fromScene))
    this.removeAll(true)
    super.destroy(fromScene)
  }
}
